module.exports = __webpack_public_path__ + "img/Lyra.582925bc.png";